import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { getSelectedCustomer } from '../../_augmentt/selectors/customers'

/**
 * Hook to return authorization flags
 */
const useAuthorization = () => {
  const selectedCustomer = useSelector(getSelectedCustomer)

  // org subscriptions
  const hasEngageAutopilotSubscription = useSelector(({ meta }) => meta.hasEngageAutopilotSubscription)
  const hasIntuneSubscription = useSelector(({ meta }) => meta.hasIntuneSubscription)
  const hasValidPostureBaselineSubscription = useSelector(({ meta }) => meta.hasValidPostureBaselineSubscription)

  // nfr licenses
  const hasNfrEngageEssentialsLicense = selectedCustomer?.hasNfrEngageEssentialsLicense
  const hasNfrSecureEssentialsLicense = selectedCustomer?.hasNfrSecureEssentialsLicense

  // licenses
  const licenses = useSelector((state) => state.licenses.data)

  const hasLicenses = useCallback(
    (licenseNames) => licenseNames.some((name) => licenses?.[name]?.hasLicense),
    [licenses],
  )

  return {
    isAuthorizedForEngageAutopilot: hasEngageAutopilotSubscription || hasNfrEngageEssentialsLicense,
    isAuthorizedForIntune: hasIntuneSubscription || hasNfrSecureEssentialsLicense,
    isAuthorizedForDiscover: hasLicenses(['discover-essentials', 'discover-premium', 'nfr-discover-essentials']),
    isAuthorizedForGroups: hasValidPostureBaselineSubscription,
  }
}

export default useAuthorization
